<template>
    <div v-if="ready">
        <v-row>
            <v-col cols="12" md="6">
            
                <fieldset>
                   <legend>{{ $t('product.policy.insertions.title') }}</legend>
                   <v-row>
                       <v-col md="6" v-if="form.rules.formula.includes('I')">
                           <v-text-field v-model="form.rules.insertions.min" :label="$t('product.policy.insertions.min.label')"
                               :class="{ '-input-success': !customValidation.errors.insertions_min }" :persistent-hint="showHint"
                               :hint="$t('product.policy.insertions.min.hint')" outlined dense></v-text-field>
                       </v-col>
                       <v-col md="6">
                           <v-text-field v-model="form.rules.insertions.max" dense :label="$t('product.policy.insertions.max.label')" :hint="$t('product.policy.insertions.max.hint')"  :persistent-hint="showHint" outlined></v-text-field>
                       </v-col>
                    </v-row>
                </fieldset>
            </v-col>
            <v-col cols="12" md="6">
                <fieldset>
                    <legend>{{ $t('product.policy.periodicity.title') }}</legend>
                    <v-row>
                        <v-col md="6">
                            <v-select  outlined dense v-model="form.rules.periodicity.type" :items="defaults.periodicity" item-text="label"
                            item-value="value" :label="$t('product.policy.periodicity.type.label')"  :persistent-hint="showHint"
                            :hint="$t('product.policy.periodicity.type.hint')"
                            ></v-select>
                        </v-col>
                        <v-col md="6">
                            <v-text-field  outlined dense v-model="form.rules.periodicity.value" :label="$t('product.policy.periodicity.value.label')" :hint="$t('product.policy.periodicity.value.hint')"  :persistent-hint="showHint"></v-text-field>
                        </v-col>
                    </v-row>
                </fieldset>
            </v-col>

        </v-row>
        <!-- <v-select :items="formulas" v-model="form.rules.formula"></v-select> -->
            <!-- <div class="d-flex" v-if="form.rules.formula.includes('Q')">
                                        <v-text-field v-model="form.rules.quantity.min" label="Qtd min" outlined></v-text-field>
                                        <v-text-field v-model="form.rules.quantity.max" label="Qtd max" outlined></v-text-field>
                                    </div> -->
        <v-row>
            <v-col md="6">
                <fieldset>
                    <legend>{{ $t('product.policy.periods.title') }}</legend>
                    <v-row>
                        <v-col md="6">
                            <v-text-field v-model="form.rules.periods.min" outlined dense :persistent-hint="showHint" :label="$t('product.policy.periods.min.label')" :hint="$t('product.policy.periods.min.hint')"></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <v-text-field v-model="form.rules.periods.max" :persistent-hint="showHint" :label="$t('product.policy.periods.max.label')" :hint="$t('product.policy.periods.max.hint')"  outlined dense></v-text-field>
                        </v-col>
                    </v-row>
                </fieldset>
            </v-col>
            <v-col md="6">
                <fieldset>
                    <legend>{{ $t('product.policy.reservation.title')}}</legend>
                    <v-row>
                         <v-col md="6">
                            <v-text-field v-model="form.rules.reservation.min" :persistent-hint="showHint" :label="$t('product.policy.reservation.min.label')" :hint="$t('product.policy.reservation.min.hint')"  outlined dense></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <v-text-field v-model="form.rules.reservation.max" :persistent-hint="showHint" :label="$t('product.policy.reservation.max.label')" :hint="$t('product.policy.reservation.max.hint')" outlined dense></v-text-field>
                        </v-col>
                    </v-row>
                </fieldset>

            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select v-model="form.rules.publishDays" :persistent-hint="showHint" :items="defaults.weekDays" item-value="v" item-text="t" multiple
                    :label="$t('product.policy.publishDays.label')" :hint="$t('product.policy.publishDays.hint')" outlined dense></v-select>
            </v-col>
            <v-col>
                <v-select v-model="form.rules.weekDays" :persistent-hint="showHint" :items="defaults.weekDays" item-value="v" item-text="t" multiple
                    :label="$t('product.policy.startWeekDay.label')" :hint="$t('product.policy.startWeekDay.hint')" outlined dense></v-select>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: {
        snap: Object,
        stores: Array,
        showHint: Boolean
    },
    data: () => ({
        form: {},
        ready: false
    }),
    created() {
        this.form = JSON.parse(JSON.stringify(this.snap))
        this.form.rules.formula = 'PI'
    },
    mounted() {
        this.ready = true
        const mediaTypes = this.$t('format.mediaTypes')
        for (let key in mediaTypes) {
            this.defaults.mediaTypes.push({ value: key, label: mediaTypes[key] })
        }

        const categories = this.$t('format.categories')
        for (let key in categories) {
            this.defaults.categories.push({ value: key, label: categories[key] })
        }
    },
    watch: {
        customValidation: {
            deep: true,
            handler(v) {
                console.log('changing-VALIDATION', this.customValidation)
                this.$emit('update-model', this.customValidation)
            }
        },
        form: {
            deep: true,
            handler(v){
                this.$emit('update-form', v)
            }
        }
    },
    computed: {
        defaults() {
            return {
                periodicity: [
                    {
                        value: 'D',
                        label: this.$t('defaults.periodicity.daily')
                    },
                    {
                        value: "W",
                        label: this.$t('defaults.periodicity.weekly')
                    },
                    {
                        value: "M",
                        label: this.$t('defaults.periodicity.monthly')
                    }
                ],
                weekDays: [
                    { v: 0, t: this.$t('defaults.weekdays[0]') },
                    { v: 1, t: this.$t('defaults.weekdays[1]') },
                    { v: 2, t: this.$t('defaults.weekdays[2]') },
                    { v: 3, t: this.$t('defaults.weekdays[3]') },
                    { v: 4, t: this.$t('defaults.weekdays[4]') },
                    { v: 5, t: this.$t('defaults.weekdays[5]') },
                    { v: 6, t: this.$t('defaults.weekdays[6]') },
                ],
                mediaTypes: [

                ],
                categories: [

                ]
            }

        },
        format() {
            const f = this.form.format
            return f.print.replace('value', f.value).replace('type', f.type).replace('metric', f.metric)
        },
        customValidation() {
            const { store, format, mediaType, description, specifications, internalCode, category, advantage } = this.form
            const result = {
                errors: {},
                ok: 0,
                percent: 0,
                total: 10
            }
            if (!this.ready) return result
            result.errors.store = !store ? 'Loja é obrigatório' : null
            result.errors.mediatype_parents = !mediaType.parents ? 'Tipo de mídia é obrigatório' : null
            result.errors.mediatype_category = !mediaType.category ? 'Categoria do tipo de mídia é obrigatório' : null
            result.errors.format_print = !format.print ? 'Ordem dos termos é obrigatório' : null
            if (format.print.includes('value')) {
                result.errors.format_value = !format.value ? 'Valor do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_value = null
            if (format.print.includes('metric')) {
                result.errors.format_metric = !format.metric ? 'Métrica do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_metric = null
            if (format.print.includes('type')) {
                result.errors.format_type = !format.type ? 'Tipo do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_type = null

            result.errors.description = !description ? 'Descrição é obrigatório' : null
            result.errors.advantage = !advantage ? 'Vantagem é obrigatório' : null
            result.errors.specifications = !specifications ? 'Especificações é obrigatório' : null
            result.errors.internalCode = !internalCode ? 'Código interno é obrigatório' : null
            // result.errors.category = !category ? 'Categoria interno é obrigatório' : null

            const errorsFind = Object.values(result.errors).filter(err => err !== null)
            result.ok = result.total - errorsFind.length
            result.percent = result.ok * 100 / result.total

            return result
        }

    },
    methods: {
        addItem() {
            this.form.buckets.push({ title: "", name: "" })
        },
        removeItem(index) {

            this.form.buckets.splice(index, 1)

        }
    }
}
</script>